import React from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Option = ({ onClick, label, icon, classNameFontAws, classNameLabel }) => {
  return (
    <div className="button" onClick={onClick}>
      <FontAwesomeIcon
        icon={icon}
        size="2x"
        color="rgb(70, 71, 73)"
        className={classNameFontAws}
      />
      <div className={classNameLabel}>{label}</div>
    </div>
  );
};

export default Option;
